var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ClinicDeatil',{attrs:{"clinicEditRoute":"FranchiseClinicEdit","backRoute":"FranchiseClinic"}})
}
var staticRenderFns = []

export { render, staticRenderFns }